import React from 'react';
import { gql } from '@apollo/client';
import {
  BooleanField,
  FunctionField,
  NumberField,
  SelectField,
  Show,
  SimpleShowLayout,
  TextField,
} from 'react-admin';
import DateTimeField from 'components/DateTimeField';
import TimestampFields from 'components/TimestampFields';
import { CASE_QUERY_OPTIONS, PermittedLinkField } from 'components/IntegrationCaseFields';
import { ELIGIBILITY_CHOICES, STATUS_CHOICES } from './List';

const OnboardingCaseShow = () => (
  <Show queryOptions={CASE_QUERY_OPTIONS} data-testid="onboarding-case-show">
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <TextField label="Case UID" source="uid" />
      <PermittedLinkField label="Company" source="location.company.name" typename="Company" />
      <PermittedLinkField label="Location" source="location.name" typename="Location" />
      <TextField label="Integration ID" source="company_integration_id" />
      <PermittedLinkField
        label="Professional ID"
        source="professional_id"
        typename="Professional"
      />
      <TextField label="Professional" source="professional.account.name" />
      <TextField label="External Request ID" source="external_request_id" />
      <DateTimeField label="Intended Start Date" source="intended_start_date" format="MM/dd/yyyy" />
      <BooleanField label="Created Professional" source="created_professional" />
      <SelectField source="status" choices={STATUS_CHOICES} />
      <FunctionField
        label="Status Reasons"
        render={(record) => record.status_reason_codes?.join(', ')}
      />
      <DateTimeField
        label="Status Effective At"
        source="status_effective_at"
        timeZone="America/Los_Angeles"
      />
      <SelectField source="eligibility" choices={ELIGIBILITY_CHOICES} />
      <FunctionField
        label="Eligibility Reasons"
        render={(record) => record.eligibility_reason_codes?.join(', ')}
      />
      <DateTimeField
        label="Eligibility Effective At"
        source="eligibility_effective_at"
        timeZone="America/Los_Angeles"
      />
      <DateTimeField label="Started At" source="started_at" timeZone="America/Los_Angeles" />
      <DateTimeField label="Withdrawn At" source="withdrawn_at" timeZone="America/Los_Angeles" />
      <NumberField label="Revision" source="state_revision" />
      <TimestampFields />
    </SimpleShowLayout>
  </Show>
);

OnboardingCaseShow.query = gql`
  query GET_ONE($id: Int!) {
    onboardingCase(id: $id) {
      id
      uid
      company_integration_id
      professional_id
      professional {
        id
        account {
          id
          name
        }
      }
      location {
        id
        name
        company {
          id
          name
        }
      }
      external_request_id
      intended_start_date
      created_professional
      status
      eligibility
      status_reason_codes
      eligibility_reason_codes
      status_effective_at
      eligibility_effective_at
      started_at
      withdrawn_at
      state_revision
      created_at
      updated_at
    }
  }
`;

export default OnboardingCaseShow;
